import { Component, ElementRef, EventEmitter, Injector, Input, OnInit, Output, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { FieldTypeEnum, OrderDirectionEnum } from '@shared/AppEnums';
import * as moment from 'moment';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { ChangeDetectorRef } from '@angular/core';
import { FilterCoordinationService } from '@shared/services/filter-coordination.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-orderable-table-column',
  templateUrl: './orderable-table-column.component.html',
  styleUrls: ['./orderable-table-column.component.css']
})
export class OrderableTableColumnComponent extends AppComponentBase implements OnInit, OnDestroy {
  @ViewChild('template') template: TemplateRef<any>;
  @ViewChild('filterDropdown', { static: false }) myDropdown: BsDropdownDirective;

  @ViewChild('filterText') filterText: ElementRef;
  @ViewChild('filterNumber') filterNumber: ElementRef;
  @ViewChild('filterDate') filterDate: ElementRef;

  @Input() currentOrder: string = '';
  @Input() columnName: string = '';
  @Input() orderDirection: OrderDirectionEnum = OrderDirectionEnum.Ascending;
  @Input() columnWidth: string = '';

  @Input() filter: boolean = false;
  @Input() filterFieldType: FieldTypeEnum = FieldTypeEnum.String;
  @Input() headerStyle: string = '';
  filterValue: string = '';
  executedValue: string = '';
  isFilterExecutedWithValue: boolean = false;

  @Output() executeOrdering: EventEmitter<any> = new EventEmitter<any>();
  @Output() executeFiltering: EventEmitter<any> = new EventEmitter<any>();

  private columnId: string;
  private filterSubscription: Subscription;

  constructor(injector: Injector, private cdr: ChangeDetectorRef, private filterCoordinationService: FilterCoordinationService) {
    super(injector);
    this.columnId = Math.random().toString(36).substr(2, 9);
  }

  ngOnInit() {
    this.filterSubscription = this.filterCoordinationService.closeFilters$.subscribe(excludeColumnId => {
      if (excludeColumnId !== this.columnId && this.myDropdown && this.myDropdown.isOpen) {
        this.myDropdown.hide();
      }
    });
  }

  ngOnDestroy() {
    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }
  }

  order(): void {
    this.executeOrdering.emit();
  }

  // FILTER
  executeFilter() {
    const stringFilterValue = this.getStringInputValue();
    this.isFilterExecutedWithValue = this.filterValue?.toString().length > 0;
    this.executedValue = this.filterValue;
    this.executeFiltering.emit(stringFilterValue);
    this.closeFilterDropdown();
  }

  onEnterPress(event: KeyboardEvent, value: string) {
    event.preventDefault();
    event.stopPropagation();
    this.filterValue = value.trim?.() || value;
    this.cdr.detectChanges();
    setTimeout(() => {
      this.executeFilter();
    }, 0);
  }

  clearFilter() {
    this.filterValue = '';
    this.executeFilter();
  }

  clearAndCloseFilterDropdown() {
    if (!this.isFilterExecutedWithValue) { this.filterValue = ''; }
    else { this.filterValue = this.executedValue; }

    this.closeFilterDropdown();
  }

  closeFilterDropdown() {
    if (this.myDropdown.isOpen) {
      this.myDropdown.hide();
    }
  }

  onOpenChange(data: boolean): void {
    if (data) {
      this.filterCoordinationService.requestCloseOtherFilters(this.columnId);
      setTimeout(() => this.setFocusOnCorrectInput(), 100);
    } else {
      this.clearAndCloseFilterDropdown();
    }
  }

  onDateChange() {
    if (this.filterFieldType === FieldTypeEnum.Date && this.filterValue) {
      setTimeout(() => this.executeFilter(), 0);
    }
  }

  setFocusOnCorrectInput() {
    switch (this.filterFieldType) {
      case FieldTypeEnum.Int:
      case FieldTypeEnum.Decimal:
        this.filterNumber.nativeElement.focus();
        break;
      case FieldTypeEnum.Date:
        this.filterDate.nativeElement.focus();
        break;
      case FieldTypeEnum.String:
      default:
        this.filterText.nativeElement.focus();
        break;
    }
  }

  mustShowTextInput(): boolean {
    return this.filterFieldType == FieldTypeEnum.String;
  }

  mustShowNumberInput(): boolean {
    return this.filterFieldType == FieldTypeEnum.Int ||
      this.filterFieldType == FieldTypeEnum.Decimal;
  }

  mustShowDateInput(): boolean {
    return this.filterFieldType == FieldTypeEnum.Date;
  }

  getStringInputValue(): string {
    if (this.filterFieldType === FieldTypeEnum.Date) {
      const date = moment(this.filterValue, 'DD/MM/YYYY', true);
      return date.isValid() ? date.format('YYYY-MM-DD') : '';
    }
    return this.filterValue?.toString() || '';
  }

  getHeaderStyle(): any {
    const baseStyle = this.headerStyle ? this.parseStyleString(this.headerStyle) : {};
    if (this.columnWidth) {
      baseStyle['width'] = this.columnWidth;
      baseStyle['min-width'] = this.columnWidth;
      baseStyle['max-width'] = this.columnWidth;
    }
    return baseStyle;
  }

  private parseStyleString(style: string): { [key: string]: string } {
    return style
      .split(';')
      .filter(rule => !!rule.trim())
      .reduce((acc, rule) => {
        const [prop, value] = rule.split(':').map(part => part.trim());
        if (prop && value) acc[prop] = value;
        return acc;
      }, {} as { [key: string]: string });
  }

}
